<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure-nxt"><span class="red"> </span></p>
<p class="QuoteAuthor_White"><span class="red CharOverride-12"> </span></p>
<p class="QuoteAuthor_White"><span class="red CharOverride-12">For Jim, always</span></p>
<p class="body-paragraph-white-center"><img alt="" class="_idGenObjectAttribute-3" src="image/1967-_Jim_&amp;_June_CROPPED.jpg"/></p>
<p class="QuoteAuthor_White ParaOverride-4"><span class="CharOverride-13">1967</span></p>
<p class="Blue_Quote"><span class="CharOverride-12">In your light I learn how to love.<br/>In your beauty, how to make poems.<br/>You dance inside my chest,<br/>where no one sees you,<br/>but sometimes I do, and that<br/>sight becomes this</span><span class="noBreak CharOverride-12"> </span><span class="CharOverride-12">art.</span></p>
<p class="QuoteAuthor_Blue">—Rumi (1207–1273)</p>
<p class="QuoteAuthor_Blue _idGenParaOverride-1"><span class="CharOverride-12">Translated by Coleman Barks</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816425039444.vue?5d87938c